import { Component, OnInit, OnDestroy } from "@angular/core";
import { NavigationService } from "../../../providers/navigation.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../../../providers/api.service";
import { Observable, Subscription, of, throwError } from "rxjs";
import { SM_CONSTANTS } from "../../../shared/constants/sm-constants";
import { MatDialog } from "@angular/material/dialog";
import { LinkedQRComponent } from "../../qr-codes/linked-qr/linked-qr.component";
import { LinkQRComponent } from "../link-qr/link-qr.component";
import { SharedService } from "../../../providers/shared.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { CreateNewBusinessComponent } from "src/app/shared/components/create-new-business/create-new-business.component";
import { UploadBusinessImageComponent } from "src/app/shared/components/upload-business-image/upload-business-image.component";
import { ViewMediaGalleryComponent } from "src/app/shared/components/view-media-gallery/view-media-gallery.component";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { MessagingService } from "src/app/providers/messaging.service";
import { AngularFireMessaging } from "@angular/fire/compat/messaging";
import { HttpClient } from "@angular/common/http";
import { catchError, delay, map, retryWhen, take } from "rxjs/operators";

@Component({
  selector: "sm-details",
  templateUrl: "./details.component.html",
  styleUrls: ["./details.component.scss"],
})
export class DetailsComponent implements OnInit, OnDestroy {
  iter1: boolean = false;
  iter2: boolean = false;

  entityHashId: string = "";
  homeQRCode: any = "";
  shopQRCode: any = "";
  _entityDetails: any[] = [];
  appFunctionality: any = []
  public loader: boolean = false;
  private _apiSubscription: Subscription  = new Subscription();
  private proxyUrl = 'https://cors-anywhere.herokuapp.com/';
  // clickEventSubscription: Subscription;
  constructor(
    private _navService: NavigationService,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private _apiService: ApiService,
    private dialog: MatDialog,
    private router: Router,
    private loaderService: LoaderServiceService,
    private _modelRef: MatDialog,
    private messagingService: MessagingService, 
    private angularFireMessaging: AngularFireMessaging,
    private http: HttpClient
  ) {
    this._navService.hideSidebarAndNav = false;
    

    


      this._apiSubscription = this._apiService.apiResult.subscribe((resData) => {
        if (resData.responseType === SM_CONSTANTS.GET_ENTITY_DETAILS_RESULT) {
          this.iter1 = true;
          console.log(resData);
          if (resData.result && resData.result != null) {
            this._entityDetails = [];
            this._entityDetails.push(resData.result[0]);
            localStorage.setItem(SM_CONSTANTS.CURRENT_ENTITY_NAME, this._entityDetails[0].entityName)
            localStorage.setItem(SM_CONSTANTS.CURRENT_ENTITY_HASH, this._entityDetails[0].hashId)
            // if(this._entityDetails[0].imageThumbUrl && this._entityDetails[0].imageThumbUrl != 'null'){
            //   this.getImageUrl(this._entityDetails[0].imageThumbUrl)
            //   .subscribe(
            //     imageUrl => {
            //       // Use the image URL
            //       this._entityDetails[0].imageThumbUrl = imageUrl
                  

            //     },
            //     error => {
            //       // Handle the error
            //       console.log(error);
                  
            //     }
            //   );
            // }
            
            this.toShowCheckHome = resData.result[0].homeServiceStatus;
            this.toShowCheckShop = resData.result[0].shopServiceStatus;
            this._entityDetails[0].addressInfo = JSON.parse(
              this._entityDetails[0].addressInfo
            );
            localStorage.setItem(
              SM_CONSTANTS.OWNER_EMPLOYEE_HASH_ID,
              this._entityDetails[0].employee_hash_id
            );
            localStorage.setItem(
              SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID,
              this._entityDetails[0].entPubHash
            );
          }
          console.log(JSON.parse(this._entityDetails[0].assetInfo));
  

          if(localStorage.getItem('newlyCreatedBusinessHash') && localStorage.getItem('newlyCreatedBusinessHash') != 'null'){
            let bHash = localStorage.getItem('newlyCreatedBusinessHash')
            const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
              width: "600px",
              data : {
                title : 'SUCCESS!',
                message : 'Your business created successfully. Now upload business and shop ownership documents in Documents section. Once they will be verified your business will be ready to get bookings from People mobile apps and websites.',
                okbtn : ' Go to Documents',
                cancelbtn : 'Ok',
                type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
              },
              disableClose : true
            });
            dialogRef.afterClosed().subscribe(result=>{
              console.log(result);
              if(result){ 
                localStorage.removeItem('newlyCreatedBusinessHash')
                this.router.navigate(["/businesses", "details", "documents"], {
                  queryParams: { entityHash: bHash },
                });
            
              }
              else {
                localStorage.removeItem('newlyCreatedBusinessHash')
              }
            })
          }
          this.loaderService.showLoader = false;
        }
        if (resData.responseType === SM_CONSTANTS.GET_BOOKING_QR_CODES_RESULT) {
          this.iter2 = true;
          console.log(resData);
          if (resData.result && resData.result != null) {
            resData.result.forEach((element: any) => {
              if (element.booking_type == "0") {
                this.homeQRCode = element.qr_code;
              } else if (element.booking_type == "1") {
                this.shopQRCode = element.qr_code;
              }
            });
          }
        }
        if (resData.responseType === SM_CONSTANTS.UNLINK_QR_CODE_RESULT) {
          console.log(resData);
          if (resData.result && resData.result != null) {
            this.ngOnInit();
          }
        }
        if (resData.responseType === SM_CONSTANTS.UPDATE_ENTITY_INFO_RESULT) {
          if (resData.result && resData.result != null) {
          //   this.loaderService.showLoader = true
          //  setTimeout(() => {
          //   this.ngOnInit()
          //  }, 1000);
          this.ngOnInit()
          }
        }
        if (resData.responseType === SM_CONSTANTS.DELETE_ENTITY_INFO_RESULT) {
          if (resData.result && resData.result != null) {
            this.router.navigate(["../"]);
          }
        }
        if (resData.responseType === SM_CONSTANTS.RESULT_API_GET_APP_FUNCTIONALITY_BY_ENTITY_ID) {
          if (resData.result && resData.result != null) {
            this.appFunctionality = resData.result

            const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Whatsapp Share')
            console.log(index);
            if(index != -1){
               if(this.appFunctionality[index].type == 1){
                localStorage.setItem(SM_CONSTANTS.WHATSAPP_ACCESS, '1')
            }else if(this.appFunctionality[index].type == 2){
              const date = new Date(this.appFunctionality[index].accessibility_end_date);
              // const date = new Date('2023-11-01T00:00:00.000Z');
              
              const newdate = new Date();
        
              date.setHours(0, 0, 0, 0);
              newdate.setHours(0, 0, 0, 0);
        
              if(newdate <= date){
                localStorage.setItem(SM_CONSTANTS.WHATSAPP_ACCESS, '1')
              }
              else {
                localStorage.setItem(SM_CONSTANTS.WHATSAPP_ACCESS, '0')
              }
            }
            }
            else{
              localStorage.setItem(SM_CONSTANTS.WHATSAPP_ACCESS, '0')
            }
           
            this._apiService.getEntityDetails(this.entityHashId);
          }
        }
        if (this.iter1 && this.iter2) {
          this.loader = false;
        }
      });
      if(!localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == null || localStorage.getItem(SM_CONSTANTS.KEY_FCM_TOKEN) == 'null'){
        this.messagingService.requestPermission();
      }

  }

  linkQR(bookingType: any) {
    this._entityDetails[0].qrBookingtype = bookingType;
    let dialogRef = this.dialog.open(LinkQRComponent, {
      width: "500px",
      disableClose: true,
      data: {
        ref: this.dialog,
        data: this._entityDetails,
      },
    });
  }

  unlinkQR(bookingType: any) {
    console.log("fired unlink");
    if (confirm("Do you want to link this QR code?")) {
      let data = {
        businessHashId: this._entityDetails[0].hashId,
        code: bookingType == 0 ? this.homeQRCode : this.shopQRCode,
      };
      this.loader = true;
      this._apiService.unlinkQRCode(data);

      // setTimeout(() => {
      //   this.ngOnInit()
      // }, 2000);
    }
  }

  deleteBusiness() {
    // if (
    //   confirm(
    //     "Are you sure you want to delete " +
    //       this._entityDetails[0].entityName +
    //       " entity?"
    //   )
    // ) {
    //   let data = {
    //     entityInfo: {
    //       hashId: this._entityDetails[0].hashId,
    //       isDelete: 1,
    //     },
    //   };

    //   this._apiService.deleteBusiness(data);
    // }

    const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
      data : {
        title : 'Alert',
        message : 'Are you sure you want to delete ' +
        this._entityDetails[0].entityName +
        ' entity?',
        okbtn : 'Yes',
        cancelbtn : 'No',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe(result=>{
      console.log(result);
      if(result){ 
        let data = {
          entityInfo: {
            hashId: this._entityDetails[0].hashId,
            isDelete: 1,
            isMediaOnly: 0
          },
        };
  
        this._apiService.deleteBusiness(data);
      }
    })
  }

  shareBusiness(){
    window.open(this._entityDetails[0].webUrl, '_blank');
  }

  ngOnInit(): void {
   

      this.loader = true;
      this.iter1 = this.iter2 = false;
      this.homeQRCode = "";
      this.shopQRCode = "";
      this.route.queryParams.subscribe((data) => {
        console.log(data.entityHash);
        this.entityHashId = data.entityHash;
      });
      this.loaderService.showLoader = true;
      this._apiService.getFunctionalityByEntityId(this.entityHashId)
  
   
    // this._apiService.getBookingQRCodes(this.entityHashId)

    // GET_ENTITY_DETAILS_RESULT

   
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe();
    // this.clickEventSubscription.unsubscribe();
  }

  openExpenses(){
    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Expenses')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "expenses"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "expenses"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }
   
  }
  openInventory(){
    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Inventory items')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "inventory"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "inventory"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }
    
   
  }
  openPurchaseList(){
    
    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Purchase list')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "purchase-list"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "purchase-list"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }
    
 
  }
  openBusinessPost(){

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Business post')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "post"], {
        queryParams: { entityHash: this._entityDetails[0].hashId, entPubHash: this._entityDetails[0].entPubHash },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "post"], {
          queryParams: { entityHash: this._entityDetails[0].hashId, entPubHash: this._entityDetails[0].entPubHash },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }

  }
  openFollowers(){

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Followers')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "followers"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "followers"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }

  }
  openReports(){


    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Reports')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "reports"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "reports"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }

  }
  openSupportTicket(){


    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Support Ticket')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "support-ticket"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "support-ticket"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }

  }
  openBookings(type: string) {

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'On-Shop Bookings')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "bookings"], {
        queryParams: {
          entityHash: this._entityDetails[0].hashId,
          bookingType: type,
        },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "bookings"], {
          queryParams: {
            entityHash: this._entityDetails[0].hashId,
            bookingType: type,
          },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }


    
  }

  openTaxAndGST() {
    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Tax and GST')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "tax-and-gst"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "tax-and-gst"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        // alert('This is a premium functionality and you need to purchase a paid pack for using it.')
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
        // dialogRef.afterClosed().subscribe(result=>{
        //   console.log(result);
        //   if(result){

        //   }
        // })
      }
    }
    
   
  }
  openDiscount() {
    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Discounts')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "discount"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "discount"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }
  }
  openCoupons() {
    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Coupons')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "coupons"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "coupons"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }
    // this.router.navigate(["/businesses", "details", "coupons"], {
    //             queryParams: { entityHash: this._entityDetails[0].hashId },
    //           });
  }
  openOnlinePayments() {
    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Online payment')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "online-payments"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "online-payments"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }
    
  }
  openDocuments(){
    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Documents')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "documents"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "documents"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }
  }
  openBookingHistory() {
    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Booking history')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "booking-history"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "booking-history"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }

  }
  createNewBusiness(){
    console.log("hello");
    let data = this._entityDetails[0].imageThumbUrl
    this._entityDetails[0].imageThumbUrl = '' 
    this._entityDetails[0].imageThumbUrl = data
}
  editBusiness() {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent,{
      width: "600px",
      data : {
        title : 'Alert',
        message : 'Once you update business info, your business will become De-Activated to be verified by Admin. During this period bookings from People apps and websites will be disabled. Though you can use all the other features without any hassle.',
        okbtn : 'Continue edit',
        cancelbtn : 'Cancel',
        type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
      },
      disableClose : true
    });
    dialogRef.afterClosed().subscribe(result=>{
      console.log(result);
      if(result){ 
        this._modelRef.open(CreateNewBusinessComponent, {
          width: "500px",
          data: {
            title: "Edit Business",
            ref: this._modelRef,
            data: this._entityDetails,
          },
        });
      }
    })
   
  }
  uploadMedia() {
    this._modelRef.open(UploadBusinessImageComponent, {
      width: "500px",
      data: {
        title: "Upload Media",
        ref: this._modelRef,
        data: this._entityDetails[0],
      },
    });
  }

  openServices() {

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Services & charges')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "services"], {
        queryParams: { entityHash: this._entityDetails[0].hashId, enPubHash: this._entityDetails[0].entPubHash  },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "services"], {
          queryParams: { entityHash: this._entityDetails[0].hashId, enPubHash: this._entityDetails[0].entPubHash },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }
    
  }

  openCustomers() {

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Customers')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "customers"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "customers"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }
    
  }
  openFeedback() {

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Feedback')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "feedback"], {
        queryParams: { entityHash: this._entityDetails[0].hashId , entityName: this._entityDetails[0].entityName},
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "feedback"], {
          queryParams: { entityHash: this._entityDetails[0].hashId , entityName: this._entityDetails[0].entityName},
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }

    
  }
  openQRCode() {

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'QR Code')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "qr-code"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "qr-code"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }



    
  }
  openPlanAndRenew() {

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Current plan & renew')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "plan-and-renew"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "plan-and-renew"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
      }
    }


   
  }

  viewMedia() {
    if (
      this._entityDetails[0].assetInfo &&
      this._entityDetails[0].assetInfo != null &&
      this._entityDetails[0].assetInfo != "null"
    ) {
      this.dialog.open(ViewMediaGalleryComponent, {
        width: "1200px",
        data: {
          title: "Media gallery",
          ref: this.dialog,
          data: JSON.parse(this._entityDetails[0].assetInfo),
          entityHash: this._entityDetails[0].hashId,
          asset_type: this._entityDetails[0].asset_type
        },
      });
    } else {
      this.dialog.open(ViewMediaGalleryComponent, {
        width: "500px",
        data: {
          title: "Media gallery",
          ref: this.dialog,
          data: [],
        },
      });
    }
  }
  toShowCheckHome: number = 1;
  toShowCheckShop: number = 1;
  onToggleChange(event: any, serviceType: any) {
    if (event.checked) {
      if (serviceType == 0) {
        this.toShowCheckHome = 1;
        let data = {
          entityInfo: {
            hashId: this._entityDetails[0].hashId,
            homeServiceStatus: 1,
            entityStatus: 1,
            isMediaOnly: 1,
            assetType: this._entityDetails[0].asset_type

          },
        };
        // Object.keys(data.entityInfo).forEach(key => {
        //   if ((data.entityInfo as any)[key] === null) {
        //     delete (data.entityInfo as any)[key];
            
        //   }
        // });
        this.loaderService.showLoader = true;
        this._apiService.updateEntityInfo(data);
      } else if (serviceType == 1) {
        this.toShowCheckShop = 1;
        let data = {
          entityInfo: {
            hashId: this._entityDetails[0].hashId,
            shopServiceStatus: 1,
            entityStatus: 1,
            isMediaOnly: 1,
            assetType: this._entityDetails[0].asset_type
          },
        };
        // Object.keys(data.entityInfo).forEach(key => {
        //   if ((data.entityInfo as any)[key] === null) {
        //     delete (data.entityInfo as any)[key];
            
        //   }
        // });
        this.loaderService.showLoader = true;
        this._apiService.updateEntityInfo(data);
      }
    } else if (!event.checked) {
      if (serviceType == 0) {
        this.toShowCheckHome = 0;
        let data = {
          entityInfo: {
            hashId: this._entityDetails[0].hashId,
            homeServiceStatus: 0,
            entityStatus: 1,
            isMediaOnly: 1,
            assetType: this._entityDetails[0].asset_type
          },
        };
        // Object.keys(data.entityInfo).forEach(key => {
        //   if ((data.entityInfo as any)[key] === null) {
        //     delete (data.entityInfo as any)[key];
            
        //   }
        // });
        this.loaderService.showLoader = true;
        this._apiService.updateEntityInfo(data);
      } else if (serviceType == 1) {
        this.toShowCheckShop = 0;
        let data = {
          entityInfo: {
            hashId: this._entityDetails[0].hashId,
            shopServiceStatus: 0,
            entityStatus: 1,
            isMediaOnly: 1,
            assetType: this._entityDetails[0].asset_type
          },
        };
        // Object.keys(data.entityInfo).forEach(key => {
        //   if ((data.entityInfo as any)[key] === null) {
        //     delete (data.entityInfo as any)[key];
            
        //   }
        // });
        this.loaderService.showLoader = true;
        this._apiService.updateEntityInfo(data);
      }
    }
  }

  openServiceTimings(type:any){

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Set Shop service timings')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "service-timings"], {
        queryParams: { serviceType: type, entityHash: this._entityDetails[0].hashId, },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "service-timings"], {
          queryParams: { serviceType: type, entityHash: this._entityDetails[0].hashId, },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }


    
  }


  openEmployees() {

    const index = this.appFunctionality.findIndex((item:any) => item.functionality_name == 'Employees')
    console.log(index);

    if(this.appFunctionality[index].type == 1){
      this.router.navigate(["/businesses", "details", "employees"], {
        queryParams: { entityHash: this._entityDetails[0].hashId },
      });
    }else if(this.appFunctionality[index].type == 2){
      const date = new Date(this.appFunctionality[index].accessibility_end_date);
      // const date = new Date('2023-11-01T00:00:00.000Z');
      
      const newdate = new Date();

      date.setHours(0, 0, 0, 0);
      newdate.setHours(0, 0, 0, 0);

      if(newdate <= date){
        this.router.navigate(["/businesses", "details", "employees"], {
          queryParams: { entityHash: this._entityDetails[0].hashId },
        });
      }
      else {
        const dialogRef = this.dialog.open(CustomConfirmDialogComponent,{
          data : {
            title : 'Alert',
            message : 'This is a premium functionality and you need to purchase a paid pack for using it.',
            okbtn : 'Buy Pack',
            cancelbtn : 'Cancel',
            type : SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE
          },
          disableClose : true
        });
        dialogRef.afterClosed().subscribe(result=>{
          console.log(result);
          if(result){ 
            this.router.navigate(["/businesses", "details", "plan-and-renew"], {
              queryParams: { entityHash: this._entityDetails[0].hashId },
            });
          }
        })
      }
    }


   
  }

  getImageUrl(url: string): Observable<string> {
    return this.http.get(this.proxyUrl + url, { responseType: 'blob' })
      .pipe(
        retryWhen(errors => errors.pipe(
          delay(1000), // Delay between retries
          take(5), // Retry at most 5 times
        )),
        map((response:any) => response.url), // Extract image URL from response
        catchError(error => {
          if (error.status === 404) {
            // Handle 404 error
            // You can display a placeholder image or show a loading indicator
            return of('../../../../assets/images/salon_support_header.png');
          } else {
            return throwError(error);
          }
        })
      );
  }

  createNotification(title:any, text:any) {
    const noti = new Notification(title, {
      body: text,
    });
  }

  test: any = "125, Raniganj By-Pass Road, Raniganj, West Bengal 713347, India"

  errorShow(){
    console.log("error hai bhai");
    
  }


}
